import { theme } from 'antd';
export default function antdTheme(brancColor, mode) {
    return {
        algorithm: mode == 'dark' ? [theme.darkAlgorithm] : [],
        token: removeUndef({
            colorPrimary: brancColor.primary,
            colorBgLayout: mode === 'light' ? '#fcfcfc' : undefined,
            colorBgTextHover: mode === 'light' ? 'rgba(0, 0, 0, 0.03)' : undefined,
            fontFamily: 'Albert Sans',
            fontSize: 14,
            borderRadius: 4
        })
    };
}
function removeUndef(theme) {
    return Object.keys(theme).reduce((acc, key) => {
        if (theme[key] === undefined)
            return acc;
        return Object.assign(Object.assign({}, acc), { [key]: theme[key] });
    }, {});
}
